/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    a: "a",
    h4: "h4",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "StyledComponent"
      }), "(", _jsx(_components.code, {
        children: "StyledComponent"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["一个样式化的 React 组件。当你使用样式调用 ", _jsx(_components.code, {
        children: "styled.tagname"
      }), " 或 ", _jsx(_components.code, {
        children: "styled(Component)"
      }), " 时，会返回该值。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A styled React component. This is returned when you\ncall ", _jsx(_components.code, {
        children: "styled.tagname"
      }), " or ", _jsx(_components.code, {
        children: "styled(Component)"
      }), " with styles."]
    }), "\n", _jsxs(_components.p, {
      children: ["该组件可以采用任何属性。如果它是有效属性，它会将其传递到 HTML 节点，否则它仅将其传递到插值函数中。（见 ", _jsx(_components.a, {
        href: "/docs/advanced#tagged-template-literals",
        children: "标记模板字面量"
      }), "）"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This component can take any prop. It passes it on to the HTML node if it's a valid attribute,\notherwise it only passes it into interpolated functions. (see ", _jsx(_components.a, {
        href: "/docs/advanced#tagged-template-literals",
        children: "Tagged Template Literal"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以毫无问题地将任意类名传递给样式组件，并且它将应用于样式调用定义的样式旁边。（例如 ", _jsx(_components.code, {
        children: "<MyStyledComp className=\"bootstrap__btn\" />"
      }), "）"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can pass an arbitrary classname to a styled component without problem and it will be applied\nnext to the styles defined by the styled call.\n(e.g. ", _jsx(_components.code, {
        children: "<MyStyledComp className=\"bootstrap__btn\" />"
      }), ")"]
    }), "\n", _jsx(_components.h4, {
      children: ".attrs(.attrs)"
    }), "\n", _jsxs(_components.p, {
      children: ["这是一个可链接的方法，它将一些属性附加到样式组件上。第一个也是唯一的参数是一个对象，它将被合并到组件的其余 props 中。", _jsx(_components.code, {
        children: "attrs"
      }), " 对象接受以下值："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is a chainable method that attaches some props to a styled component.\nThe first and only argument is an object that will be merged into the rest of the\ncomponent's props. The ", _jsx(_components.code, {
        children: "attrs"
      }), " object accepts the following values:"]
    }), "\n", _jsxs(Table, {
      head: ['Values', 'Description'],
      children: [_jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "Prop Value"
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "These can be of any type, except functions. They'll stay static and\nwill be merged into the existing component props."
          })
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "Prop Factory"
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "A function that receives the props that are passed into the component\nand computes a value, that is then going to be merged into the\nexisting component props."
          })
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["返回另一个 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Returns another ", _jsx(_components.code, {
        children: "StyledComponent"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled from 'styled-components'\n\nconst Input = styled.input.attrs<{ $padding?: string; $small?: boolean; }>(props => ({\n  type: 'text',\n  size: props.$small ? 5 : undefined,\n}))`\n  border-radius: 3px;\n  border: 1px solid #BF4F74;\n  display: block;\n  margin: 0 0 1em;\n  padding: ${props => props.$padding};\n\n  ::placeholder {\n    color: #BF4F74;\n  }\n`\n\nrender(\n  <>\n    <Input $small placeholder=\"Small\" />\n    <Input placeholder=\"Normal\" />\n    <Input $padding=\"2em\" placeholder=\"Padded\" />\n  </>\n)\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.a, {
        href: "/docs/basics#attaching-additional-props",
        children: "附加额外属性"
      }), " 部分了解有关此构造函数的更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Learn more about this constructor in the ", _jsx(_components.a, {
        href: "/docs/basics#attaching-additional-props",
        children: "Attaching Additional Props"
      }), " section."]
    }), "\n", _jsxs(_components.h4, {
      children: [_jsx(_components.code, {
        children: "\"as\""
      }), " 多态属性(", _jsx(_components.code, {
        children: "\"as\""
      }), " polymorphic prop)"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "\"as\""
      }), " polymorphic prop"]
    }), "\n", _jsx(_components.p, {
      children: "| v4"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你想保留应用于组件的所有样式，但只是切换最终渲染的内容（无论是不同的 HTML 标签还是不同的自定义组件），你可以使用 ", _jsx(_components.code, {
        children: "\"as\""
      }), " 属性在运行时执行此操作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you want to keep all the styling you've applied to a component but just switch out what's being ultimately rendered (be it a different HTML tag or a different custom component), you can use the ", _jsx(_components.code, {
        children: "\"as\""
      }), " prop to do this at runtime."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled from \"styled-components\";\n\nconst Component = styled.div`\n  color: red;\n`;\n\nrender(\n  <Component\n    as=\"button\"\n    onClick={() => alert('It works!')}\n  >\n    Hello World!\n  </Component>\n)\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "这种东西在像导航栏这样的用例中非常有用，其中一些项目应该是链接，有些只是按钮，但所有项目的样式都相同。"
    }), "\n", _jsx(_components.p, {
      children: "¥This sort of thing is very useful in use cases like a navigation bar where some of the items should be links and some just buttons, but all be styled the same way."
    }), "\n", _jsx(_components.h4, {
      children: "\"forwardedAs\" 属性(\"forwardedAs\" prop)"
    }), "\n", _jsx(_components.p, {
      children: "¥\"forwardedAs\" prop"
    }), "\n", _jsx(_components.p, {
      children: "| v4.3"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你选择使用也接受 ", _jsx(_components.code, {
        children: "\"as\""
      }), " 属性的 ", _jsx(_components.code, {
        children: "styled()"
      }), " HOC 封装另一个组件，请使用 ", _jsx(_components.code, {
        children: "\"forwardedAs\""
      }), " 将所需的属性传递给封装的组件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you choose to wrap another component with the ", _jsx(_components.code, {
        children: "styled()"
      }), " HOC that also accepts an ", _jsx(_components.code, {
        children: "\"as\""
      }), " prop, use ", _jsx(_components.code, {
        children: "\"forwardedAs\""
      }), " to pass along the desired prop to the wrapped component."]
    }), "\n", _jsx(_components.h4, {
      children: "瞬态属性(Transient props)"
    }), "\n", _jsx(_components.p, {
      children: "¥Transient props"
    }), "\n", _jsx(_components.p, {
      children: "| v5.1"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你想阻止样式组件使用的 props 被传递到底层 React 节点或渲染到 DOM 元素，你可以在 prop 名称前加上美元符号 (", _jsx(_components.code, {
        children: "$"
      }), ")，将其变成瞬态 prop。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you want to prevent props meant to be consumed by styled components from being passed to the underlying React node or rendered to the DOM element, you can prefix the prop name with a dollar sign (", _jsx(_components.code, {
        children: "$"
      }), "), turning it into a transient prop."]
    }), "\n", _jsxs(_components.p, {
      children: ["在此示例中，", _jsx(_components.code, {
        children: "$draggable"
      }), " 不像 ", _jsx(_components.code, {
        children: "draggable"
      }), " 那样渲染到 DOM。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In this example, ", _jsx(_components.code, {
        children: "$draggable"
      }), " isn't rendered to the DOM like ", _jsx(_components.code, {
        children: "draggable"
      }), " is."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Comp = styled.div`\n  color: ${props =>\n    props.$draggable || 'black'};\n`;\n\nrender(\n  <Comp $draggable=\"red\" draggable=\"true\">\n    Drag me!\n  </Comp>\n);\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "shouldForwardProp(shouldForwardProp)"
    }), "\n", _jsx(_components.p, {
      children: "| v5.1"
    }), "\n", _jsxs(_components.p, {
      children: ["这是一种比瞬态 prop 更动态、更精细的过滤机制。在多个高阶组件组合在一起并且碰巧共享相同的 prop 名称的情况下，它非常方便。", _jsx(_components.code, {
        children: "shouldForwardProp"
      }), " 的工作方式与 ", _jsx(_components.code, {
        children: "Array.filter"
      }), " 的谓词回调非常相似。测试失败的 prop 不会传递到底层组件，就像瞬态 prop 一样。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is a more dynamic, granular filtering mechanism than transient props. It's handy in situations where multiple higher-order components are being composed together and happen to share the same prop name.", _jsx(_components.code, {
        children: "shouldForwardProp"
      }), " works much like the predicate callback of ", _jsx(_components.code, {
        children: "Array.filter"
      }), ". A prop that fails the test isn't passed down to underlying components, just like a transient prop."]
    }), "\n", _jsxs(_components.p, {
      children: ["请记住，如本例所示，其他可链接方法应始终在 ", _jsx(_components.code, {
        children: ".withConfig"
      }), " 之后执行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Keep in mind that, as in this example, other chainable methods should always be executed after ", _jsx(_components.code, {
        children: ".withConfig"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Comp = styled('div').withConfig({\n  shouldForwardProp: (prop) =>\n      !['hidden'].includes(prop),\n}).attrs({ className: 'foo' })`\n  color: red;\n  &.foo {\n    text-decoration: underline;\n  }\n`;\n\nrender(\n  <Comp hidden>\n    Drag Me!\n  </Comp>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["（可选）", _jsx(_components.code, {
        children: "shouldForwardProp"
      }), " 可以采用第二个参数来提供对默认验证器函数的访问。这个函数可以用作后备，当然，它也可以像谓词一样工作，根据已知的 HTML 属性进行过滤。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Optionally, ", _jsx(_components.code, {
        children: "shouldForwardProp"
      }), " can take a second parameter that provides access to the default validator function. This function can be used as a fallback, and of course, it also works like a predicate, filtering based on known HTML attributes."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
